import { jsx as _jsx } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Button } from "@sundae/ui-toolkit";
import cx from "classnames";
import { useBrandConfig } from "../../hooks";
import { Actions, useAppContext } from "../../stores";
export const WalletButton = ({ size = "sm" }) => {
    const { t } = useI18N();
    const { dispatch } = useAppContext();
    const brand = useBrandConfig();
    return (_jsx(Button, { className: cx(brand?.classes.buttons.all, brand?.classes.buttons.colored), variant: "colored", size: size, onClick: () => {
            Actions.setConnectWalletOpen(true, dispatch);
        }, children: t("wallet.button_connect") }));
};
export default WalletButton;
//# sourceMappingURL=WalletButton.js.map